/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * See codegen config in .graphqlrc.yml for details
 */

import gql from 'graphql-tag';
import * as Urql from 'urql';

import type * as Types from '@sg/graphql-schema';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type ReorderModalDeliveryContextQueryVariables = Types.Exact<{
  input: Types.LocationByAddressInput;
}>;

export type ReorderModalDeliveryContextQuery = {
  readonly __typename?: 'Query';
  readonly locationByAddress:
    | { readonly __typename: 'InvalidInput' }
    | {
        readonly __typename: 'Location';
        readonly restaurant: {
          readonly __typename: 'Restaurant';
          readonly id: string;
          readonly slug: string;
          readonly name: string;
          readonly deliveryFee: number;
        };
        readonly vendor: {
          readonly __typename?: 'Vendor';
          readonly name: string;
          readonly restaurantId: string;
        };
      }
    | { readonly __typename: 'NoValidRestaurants' }
    | { readonly __typename: 'ValidationError' };
};

export const ReorderModalDeliveryContextDocument = gql`
  query ReorderModalDeliveryContext($input: LocationByAddressInput!) {
    locationByAddress(input: $input) {
      __typename
      ... on Location {
        restaurant {
          id
          __typename
          slug
          name
          deliveryFee
        }
        vendor {
          name
          restaurantId
        }
      }
    }
  }
`;

export function useReorderModalDeliveryContextQuery(
  options: Omit<Urql.UseQueryArgs<ReorderModalDeliveryContextQueryVariables>, 'query'>,
) {
  return Urql.useQuery<ReorderModalDeliveryContextQuery, ReorderModalDeliveryContextQueryVariables>(
    { query: ReorderModalDeliveryContextDocument, ...options },
  );
}
